import { LocationProvider } from '@reach/router';
import React, { useLayoutEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import styled, { ThemeProvider } from 'styled-components';

import { merge } from 'lodash';
import screenSizes from './screenSizes';
import theme from './theme';

import 'rc-slider/assets/index.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-toastify/dist/ReactToastify.css';
import 'rodal/lib/rodal.css';
import './App.css';

import ContentRouter from './components/ContentRouter';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import useCustomTheme from './hooks/useCustomTheme';
import { reachHistory } from './store';

import storageService from './services/storageService';

const AppInner = () => {
  const domainURL = window.location.hostname.split('.')[0];
  const { customTheme } = useCustomTheme({ partnerPrefix: domainURL });
  const newTheme = merge({ ...theme }, { ...customTheme });
  const userDefaultLang = storageService.getItem('psLang');
  
  useLayoutEffect(() => {
    if (!userDefaultLang) {
      storageService.setItem('psLang', 'en');
    }
    return () => { };
  }, []);

  return (
    <>
      <StyledToastContainer autoClose={3000} position="bottom-right" hideProgressBar />
      <LocationProvider history={reachHistory}>
        <ThemeProvider theme={{ ...newTheme, screenSizes }}>
          <ErrorBoundary>
            <ContentRouter />
          </ErrorBoundary>
        </ThemeProvider>
      </LocationProvider>
    </>
  );
};

const StyledToastContainer = styled(ToastContainer)`
  background-color: transparent;
`;

export default AppInner;
